import type { OrgMe } from "@/types/api";
import { http } from "./http";

/**
 * The org itself — identity, plan, seat counts, entitlements.
 *
 * Deliberately narrow: roster work lives in members.service, activity in
 * usage.service, branding in settings.service.
 */
export const orgService = {
	/** Bootstrap call. Everything the shell needs before any screen renders. */
	getMe: (signal?: AbortSignal) => http.get<OrgMe>("/api/org/me", { signal }),
};
